/**
 * Hero Videos transition functionality
 *
 * @since		09/21/2020
 * @author		<john@chatmandesign.com>
 * @link		http://chatmandesign.com
 */

 (function($) {
    let mummyVideo = '.mummy-video';

    function cycleMummyVideos() {        
        let videos = $(mummyVideo).find('.container');
        let numVideos = videos.length;
        let lastVideo = videos[numVideos - 1];
        let currentVideo = '';
        let nextVideo = '';
        let isRepeat = true;

        isRepeat = $(lastVideo).hasClass('active');

        if( isRepeat ) {
            currentVideo = $(lastVideo);
            nextVideo = $(videos[0]);
        } else {
            currentVideo = $(mummyVideo).find('.container.active');
            nextVideo = $(currentVideo).next('.container').first();
        }

        currentVideo.removeClass('active');
        nextVideo.addClass('active');
    }

    function initMummyVideos() {
        setInterval(function() {
            cycleMummyVideos();
        }, 4000);
    }

    $(window).on('load', function() {
        initMummyVideos();
    });


})(jQuery)